import React from "react";
import { getBezierPath } from '@xyflow/react';

import { useCustomCampaignShowContext } from "./CustomCampaignShowContainer";

const edgePathStyle = {
  fill: "none",
  stroke: "var(--sl-border-primary)",
  strokeWidth: 1,
};

const edgeButtonStyle = {
  cursor: "pointer",
  pointerEvents: "all",
  fill: "var(--sl-bg-brand-solid)",
};

const dropZoneStyle = {
  fill: "var(--sl-border-secondary)",
  strokeWidth: 1,
  stroke: "var(--sl-border-primary)",
  strokeDasharray: "4, 2",
};

const edgeButtonTextStyle = {
  pointerEvents: "none",
  userSelect: "none",
  fill: "var(--sl-text-white)",
};

const internalIdTextStyle = {
  pointerEvents: "none",
  userSelect: "none",
  fill: "var(--sl-text-primary)",
};

const WorkflowEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  data,
}) => {
  const {
    targetEdgeInternalId,
    setSelectedNode,
    setBuilding,
    building,
  } = useCustomCampaignShowContext();

  const isHovering = targetEdgeInternalId === data.internalId;

  const [edgePath, edgeCenterX, edgeCenterY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <path
        id={id}
        style={edgePathStyle}
        d={edgePath}
        markerEnd={markerEnd}
      />
      {data.buildable && building ? (
        <g transform={`translate(${edgeCenterX}, ${edgeCenterY})`}>
          {isHovering ? (
            <rect
              x={-90}
              y={-10}
              width={180}
              ry={4}
              rx={4}
              height={20}
              style={dropZoneStyle}
            />
          ) : (
            <>
              <rect
                x={-6}
                y={-6}
                width={12}
                ry={10}
                rx={10}
                height={12}
                style={edgeButtonStyle}
                onClick={() => { setSelectedNode(null); setBuilding(true); }}
              />
              <text style={edgeButtonTextStyle} y={5} x={-4}>
                +
              </text>
            </>
          )}
        </g>
      ) : null}
    </>
  );
};

export default WorkflowEdge;
